<template>
  <!-- 复合题 -->
  <div
    class="compound-question-wrap"
    :class="{
      ['question_' + questionInfo.id]: true,
    }"
  >
    <div class="question-cont-box">
      <div class="question-info-wrap">
        <div class="scroll-wrap" :style="handleScrollWrapStyle">
          <!-- 题型 -->
          <question-type
            :info="{
              question_type: questionInfo.question_type,
              score: questionInfo.score * questionInfo?.child?.length,
            }"
          />
          <!-- 完型填空题干 -->
          <div
            v-if="
              questionInfo.question_type ===
              QUESTION_TYPE_NAME.COMPLETE_BLANK_FILL
            "
            v-html="handleContent(questionInfo.content)"
            class="question-content complete-blank-fill"
          ></div>
          <!-- 阅读理解题干 -->
          <div v-else class="question-content" v-html="questionInfo.content" />
        </div>
      </div>
    </div>
    <sub-question-dialog
      ref="subQuestionDialog"
      :swiper-index="swiperIndex"
      :question-info="questionInfo"
      v-model="activeSubId"
      @dialog-height-change="handleDialogHeightChange"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { EventBus } from "@saas/components/src/utils/event-bus";
import {
  QUESTION_TYPE_NAME,
  WORK_STATUS,
} from "@saas/components/src/constants/question";
import ChoiceQuestion from "@saas/pages/src/homework/components/ChoiceQuestion.vue";
import QuestionType from "@saas/pages/src/homework/components/QuestionType.vue";
import SubQuestionDialog from "@saas/pages/src/homework/components-mobile/SubQuestionDialog.vue";
export default {
  props: {
    questionInfo: {
      type: Object,
      default: () => ({}),
    },
    swiperIndex: {
      type: Number,
      default: null,
    },
  },
  data: function () {
    return {
      changing: false,
      activeSubId: null,
      QUESTION_TYPE_NAME,
      // activeIndex: 0,
      WORK_STATUS,
      dialogHeight: 0,
    };
  },
  components: {
    QuestionType,
    // ChoiceQuestion,
    SubQuestionDialog,
  },
  mounted() {
    // 默认选中第一个
    this.activeSubId = this.hadleQuestionChild?.[0]?.id;
    // 完型填空题干按钮-初始化
    if (
      this.questionInfo?.question_type ===
      QUESTION_TYPE_NAME.COMPLETE_BLANK_FILL
    ) {
      this.initQuestionButtonClick();
    }
  },
  methods: {
    handleDialogHeightChange(newHeight) {
      this.dialogHeight = newHeight;
    },
    initQuestionButtonClick() {
      this.$nextTick(() => {
        setTimeout(() => {
          // 事件委托
          let questionBtnsParent = document.querySelector(
            `.question_${this.questionInfo.id} .question-content.complete-blank-fill`
          );
          questionBtnsParent.addEventListener("click", (e) => {
            let item = e.target;
            if (e.target.classList.contains("question-button")) {
              console.log("点击事件触发");
              if (this.showErrorAnalysis) {
                // 错题解析-非正确题按钮点击事件添加
                if (!item.classList.contains("is-right")) {
                  this.handleQuestionBtnClick(item);
                }
              } else {
                this.handleQuestionBtnClick(item);
              }
            }
            e.stopPropagation();
          });
        }, 250);
      });
    },
    // 完型填空题干按钮-点击事件
    handleQuestionBtnClick(item) {
      const id = Number(item.getAttribute("data-id"));
      const subIndex = Number(item.getAttribute("sub-index"));
      this.handleSubIndexClick({
        id,
        subIndex,
      });
    },
    // 阅读理解-监听滚动-高亮题号
    handleScroll(event) {
      if (this.changing) return;
      const { scrollTop } = event.target;
      // 1. 将对象的属性名提取到一个数组中
      const propertyKeys = [];
      for (const key in this.$refs) {
        propertyKeys.push(key);
      }
      // 2. 对数组进行倒序遍历
      for (let i = propertyKeys.length - 1; i >= 0; i--) {
        const key = propertyKeys[i];
        const element = this.$refs[key]?.[0]?.$el;
        const judge = scrollTop >= element?.offsetTop;
        if (judge) {
          this.activeSubId = Number(key.replace("question_", ""));
          break;
        }
      }
    },
    handleSubIndexClick(subQuestionInfo) {
      this.$refs?.subQuestionDialog?.handleSubIndexClick(subQuestionInfo);
    },
  },
  computed: {
    ...mapState("defaultHomework", [
      "workInfo",
      "questionList",
      "isCorrected",
      "showErrorAnalysis",
    ]),
    ...mapGetters("defaultHomework", ["questionIndexObj"]),
    handleScrollWrapStyle() {
      return {
        paddingBottom: this.dialogHeight ? `${this.dialogHeight + 10}px` : "",
      };
    },
    handleSubIndexClass() {
      return (subQuestionInfo) => {
        const { right, userAnswer } = subQuestionInfo;
        return {
          "is-active": this.activeSubId === subQuestionInfo.id,
          "is-answer": userAnswer,
          "is-right": this.isCorrected && userAnswer && right === 1,
          "is-wrong": this.isCorrected && userAnswer && right === 2,
        };
      };
    },
    showSingleQuestion() {
      return (
        this.questionInfo.question_type ===
          QUESTION_TYPE_NAME.COMPLETE_BLANK_FILL || this.isCorrected
      );
    },
    hadleQuestionChild() {
      if (this.showErrorAnalysis) {
        return this.questionInfo?.errorChild || [];
      } else {
        return this.questionInfo.child || [];
      }
    },
    // 会实时渲染完型题干中按钮状态
    handleContent() {
      return (htmlString) => {
        try {
          // 去除零宽度空格
          const cleanHtmlString = htmlString.replace(/\u200B/g, "");
          let index = 0; //问题序号
          const newHtmlString = cleanHtmlString.replace(
            // eslint-disable-next-line no-irregular-whitespace
            /<question-button([^>]*)>﻿<span[^>]*>问 (\d+)<\/span>﻿<\/question-button>/g,
            (match, attributes, number) => {
              // 移除样式属性和class
              let newAttributes = attributes.replace(/style="[^"]*"/, "");
              newAttributes = newAttributes.replace(/class="[^"]*"/, "");
              // 构建新的 question-button 标签
              let { id, right, userAnswer } = this.questionInfo?.child?.[index]; //问题详情
              number = this.questionIndexObj?.[id] + 1; // 整个作业中的序号
              let otherClass = []; // 其他类名
              if (userAnswer) {
                otherClass.push("is-answer");
              }
              if (this.activeSubId === id) {
                otherClass.push("is-active");
              }
              if (this.isCorrected && userAnswer) {
                if (right === 1) {
                  otherClass.push("is-right");
                } else if (right === 2) {
                  otherClass.push("is-wrong");
                }
              }
              otherClass = otherClass.join(" ");
              // eslint-disable-next-line no-irregular-whitespace
              const newButton = `<question-button${newAttributes} class='question-button question-btn-${
                id || ""
              } ${
                otherClass || ""
              }' data-id=${id} sub-index=${index}>${number}</question-button>`;
              index++;
              return newButton;
            }
          );
          return newHtmlString;
        } catch (error) {
          console.log(error, "error===");
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.compound-question-wrap {
  position: relative;
  height: 100%;
  padding: 0.32rem 0.32rem 0 0.48rem;
  .question-cont-box {
    height: 100%;
  }
  .question-info-wrap {
    height: 100%;
  }
  .mobile-question-type-wrap {
    width: 100%;
  }
  .scroll-wrap {
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-bottom: calc(45vh + 0.32rem);
  }
  ::v-deep .question-content {
    font-weight: 500;
    font-size: 0.43rem;
    color: #1d2129;
    line-height: 0.69rem;
    line-break: anywhere;
    .question-button {
      position: relative;
      top: -0.06rem;
      display: inline-block;
      width: 0.59rem;
      height: 0.59rem;
      background: #f2f3f5;
      border: 0.03rem solid #f2f3f5;
      border-radius: 50%;
      text-align: center;
      margin: 0 0.11rem;
      position: relative;
      cursor: pointer;
      color: #4e5969;
      font-weight: 600;
      font-size: 0.37rem;
      color: #4e5969;
      line-height: 0.55rem;
      &::after {
        left: -0.08rem;
        bottom: -0.06rem;
        position: absolute;
        content: "";
        display: flex;
        width: 0.75rem;
        height: 0.03rem;
        background: #86909c;
        border-radius: 0.03rem;
      }
      &.is-active {
        border-color: #86909c;
        color: #4e5969;
        background-color: #f2f3f5;
      }
      &.is-answer {
        background: $homework-default-bg;
        color: $homework-default-color;
        border-color: $homework-default-bg;
        &.is-active {
          border-color: #386bff;
        }
      }
      &.is-right {
        background: $homework-right-bg;
        color: $homework-right-color;
        border-color: $homework-right-bg;
        &.is-active {
          border-color: $homework-right-color;
        }
      }
      &.is-wrong {
        background: $homework-wrong-bg;
        color: $homework-wrong-color;
        border-color: $homework-wrong-bg;
        &.is-active {
          border-color: $homework-wrong-color;
        }
      }
    }
  }
}
</style>
